import { getJSON } from '../RestHandler';

async function getAzureStorageInfo() {
    let response = await getJSON('/home/GenerateSasToken');
    return response;
}

export { getAzureStorageInfo };



// WEBPACK FOOTER //
// ./demo/src/services/SasGeneratorService.js